import { ChangeDetectionStrategy, Component, Input, OnInit, TemplateRef, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SpotLightDialogComponent } from './spotlight-dialog/spotlight-dialog.component';

@Component({
    selector: 'fuse-search-launcher',
    templateUrl: './search-launcher.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'fuseSearchLauncher'
})
export class FuseSearchLauncherComponent implements OnInit {
    @Input() iconTpl: TemplateRef<any>;
    @Input() tooltip: string;

    /**
     * Constructor
     */
    constructor(
        private _matDialog: MatDialog,
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle the search launcher mode
     */
    toggleSearchLauncher(): void {
        this._matDialog.open(SpotLightDialogComponent, {
            maxWidth: '900px',
            width: '100%',
            position: { top: '100px' },
            panelClass: 'spotlight-dialog-container',
            autoFocus: true
        });
    }

}
